///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.nbe_items = abcsetup.nbe_items || {};
abcsetup.nbe_items.index = abcsetup.nbe_items.index || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.nbe_items.index = {
    init: function() {
        $('#nbe_item_import_btn').prop('disabled', true);

        $('#nbe_item_import').on('change', function() {
            if ($(this).val() != '') {
                $('#nbe_item_import_btn').prop('disabled', false);
            } else {
                $('#nbe_item_import_btn').prop('disabled', true);
            }
        });

        $('.alert').alert();
    },   
}